/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: caoran
 * @LastEditTime: 2025-02-13 17:04:11
 */
import React, { useEffect, useMemo } from 'react'
import { Modal } from 'antd'
import dropboxImg from '../../../../images/uploadPhotos/dropbox.png'
import {
  useAppSelector,
  usePayment,
  useSensorsRole,
  useVip
} from '../../../../app/hooks'
import { useFileNums } from '../hooks'
import sensors from '../../../../utils/sensors'

const RequireVipDialog = ({ fileList, visible, onClose }) => {
  const payment = usePayment()
  const groupID = useAppSelector((state) => state.group.groupId)
  const role = useSensorsRole()
  const { photosNum, videosNum, totalSize } = useFileNums(fileList)
  const totalSizeMB = useMemo(() => {
    const size = fileList.reduce((acc, file) => {
      return acc + file.size
    }, 0)
    return Math.round(size / (1024 * 1024))
  }, [fileList])

  const handlePaymentClick = () => {
    sensorsEvent('clickOpenSvip')
    //
    payment.openSvip('webBigbatchUpload', false, false, true)
  }

  const sensorsEvent = (actionType) => {
    sensors.track('web_get_action_bigbatch_upload_wait', {
      actionType,
      photoNum: photosNum,
      videoNum: videosNum,
      fileSize: totalSizeMB,
      groupID,
      role
    })
  }

  useEffect(() => {
    if (photosNum || videosNum) {
      sensorsEvent('showPop')
    }
  }, [photosNum, videosNum])

  return (
    <Modal
      open={visible}
      getContainer={false}
      wrapClassName="require-vip-modal"
      width={606}
      style={{ height: '540px' }}
      mask={{ closable: false }}
      footer={null}
      onCancel={onClose}
    >
      <h3>
        共有 <span>{photosNum}</span> 张照片，<span>{videosNum}</span>{' '}
        个视频待上传
      </h3>
      <h3>
        共 <span>{totalSize}</span> 的内存占用
      </h3>
      <img className="dropbox-img" src={dropboxImg} alt="" />
      <button className="open-vip-btn" onClick={handlePaymentClick}>
        开通高级会员，批量上传
      </button>
    </Modal>
  )
}

export default RequireVipDialog
